import Scrollbar from 'smooth-scrollbar';

Scrollbar.initAll({
  damping: .1,
});